var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCloseCircle24 = function SvgLightIcnCloseCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m3.5 10.625-.875.875L12 12.875 9.375 15.5l-.875-.875L11.125 12 8.5 9.375l.875-.875L12 11.125 14.625 8.5l.875.875L12.875 12z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m15.5 14.625-.875.875L12 12.875 9.375 15.5l-.875-.875L11.125 12 8.5 9.375l.875-.875L12 11.125 14.625 8.5l.875.875L12.875 12z",
    clipRule: "evenodd",
    opacity: 0.8
  })));
};
export default SvgLightIcnCloseCircle24;